import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ChevronLeft, ArrowUpRight } from 'lucide-react';

const SUPPORT_EMAIL = 'support@verigrc.com';

/**
 * Support Contacts — a static help landing (D-HUB-2-4). The channel is email, shown
 * unconditionally. No phone, no forms, no API.
 */
export function SupportContactsPage() {
  useEffect(() => { document.title = 'Support Contacts — VeriGRC'; }, []);

  return (
    <div className="mx-auto max-w-3xl space-y-7">
      <Link
        to="/settings"
        className="inline-flex items-center gap-1.5 text-sm font-medium text-text-secondary transition-colors hover:text-text-primary"
      >
        <ChevronLeft className="h-4 w-4" />
        All Settings
      </Link>

      <div>
        <div className="text-[11px] font-semibold uppercase tracking-[0.16em] text-text-secondary">Support</div>
        <h1 className="mt-2 text-2xl font-bold text-text-primary">Support Contacts</h1>
        <p className="mt-1 text-sm text-text-secondary">
          Get help with VeriGRC — reach our support team.
        </p>
      </div>

      {/* Email */}
      <div className="flex items-center gap-4 rounded-2xl border border-border-subtle bg-bg-surface p-5">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-accent-sky-dim text-accent-sky">
          <Mail className="h-5 w-5" />
        </span>
        <div className="min-w-0 flex-1">
          <div className="text-sm text-text-secondary">Email our support team</div>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="mt-0.5 inline-block text-base font-semibold text-text-primary hover:text-accent-cyan"
          >
            {SUPPORT_EMAIL}
          </a>
        </div>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="inline-flex shrink-0 items-center gap-2 rounded-lg border border-border-subtle bg-bg-surface-2 px-4 py-2 text-sm font-semibold text-text-primary transition-colors hover:bg-bg-surface"
        >
          Compose
          <ArrowUpRight className="h-3.5 w-3.5" />
        </a>
      </div>

      <p className="text-xs leading-relaxed text-text-secondary">
        Support requests are typically answered within one business day.
      </p>
    </div>
  );
}
